import * as yup from 'yup';

export const FineImageSchema = yup.object({
  viewAll: yup.boolean().required(),
});
